// @flow
import type { ComponentType } from 'react';
import React from 'react';

import styles from './header.css';


type HeaderPropTypes = {
  title: React$Node,
  badgeCount?: number,
  ActionIcon?: ComponentType<*>,
  ActionComponent?: ComponentType<*>,
  action?: Function,
  className?: string,
};

export default ({
  title,
  badgeCount = 0,
  ActionIcon,
  ActionComponent,
  action,
  className = '',
}: HeaderPropTypes) => (
  <div
    className={
      `
        ${className}
        ${styles.header}
      `
    }
  >
    <div className={styles.titleContainer}>
      {title}
    </div>
    {
      badgeCount > 0 && (
        <div className={styles.badge}>
          { badgeCount }
        </div>
      )
    }
    {
      ActionComponent && (
        <div className={styles.actionContainer}>
          <ActionComponent />
        </div>
      )
    }
    {
      !ActionComponent && ActionIcon && (
        <div className={styles.actionContainer}>
          <button
            type="actionButton"
            onClick={
              (e: MouseEvent) => {
                if (action) {
                  action();
                }
                e.stopPropagation();
              }
            }
          >
            <ActionIcon size={30} />
          </button>
        </div>
      )
    }
  </div>
);



// WEBPACK FOOTER //
// ./src/scripts/components/Accordion/Header/index.jsx